var _excluded = ["show", "defaultStyle", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { getZIndex } from '@okee-uikit/react-hooks';
var DEFAULT_STYLE = {
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0
};
export function RcMask(props) {
  var _props$show = props.show,
      show = _props$show === void 0 ? false : _props$show,
      _props$defaultStyle = props.defaultStyle,
      defaultStyle = _props$defaultStyle === void 0 ? true : _props$defaultStyle,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      extra = _objectWithoutProperties(props, _excluded);

  var zIndex = style.zIndex;

  if (defaultStyle && typeof zIndex !== 'number') {
    zIndex = getZIndex();
  }

  return React.createElement("div", _objectSpread(_objectSpread({}, extra), {}, {
    style: _objectSpread(_objectSpread(_objectSpread({}, defaultStyle ? DEFAULT_STYLE : {}), style), {}, {
      zIndex: zIndex,
      display: !show ? 'none' : 'block'
    })
  }));
}